import React from "react";
import type { SVGProps } from "react";

const CexBalanceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.73705 8.73705C9.81211 7.66199 10.9375 6.74538 12.045 6.01308M12.045 6.01308C15.1085 3.98733 18.0344 3.37187 19.3763 4.71372C21.2032 6.54066 19.4019 11.304 15.353 15.353C11.304 19.4019 6.54066 21.2032 4.71372 19.3763C3.38324 18.0458 3.97704 15.1579 5.96189 12.1228M12.045 6.01308C8.98151 3.98735 6.05557 3.3719 4.71372 4.71374C2.88679 6.54068 4.6881 11.304 8.73705 15.353M12.045 6.01308C13.1524 6.74539 14.2779 7.662 15.353 8.73707M18.1281 12.1228C20.113 15.1579 20.7068 18.0458 19.3763 19.3763C18.0397 20.7129 15.1315 20.1075 12.0812 18.1008M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
      stroke="#383838"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default CexBalanceIcon;

